import React from 'react';
import { Dropdown, Menu } from 'grab-ui';
import { MoreHorizontalUniversal } from '@duxton-web/icons';
import { colorBaseNeutral700 } from '@duxton-web/design-tokens/themes/light';
import './SingleSelectMenu.scss';

type MenuOption = {
  displayName: string,
  value: string,
  icon: Object,
  callback: Function, // the function takes in two parameters: action value, projectID
};

type Props = {
  trigger: 'string',
  project: Object,
  options: Array<MenuOption>,
  overlayConfig: { // Object to adjust the position of dropdown container
    customClassName: string,
    xAxisCorrection: number,
    yAxisCorrection: number,
  }
};

const SingleSelectMenu = (props: Props) => {
  return (
    <Dropdown
      trigger={props.trigger ? [props.trigger] : ['click']}
      overlayClassName={props.overlayConfig ? props.overlayConfig.customClassName : ''}
      overlayStyle={{ opacity: props.overlayConfig ? '0' : '1', zIndex: '1000' }}
      onVisibleChange={state => {
        // as the overlay becomes visible, the x and y axis position of the overlay is adjusted.
        // to avoid sudden movement we show the overlay after the position is adjusted.
        if (state) {
          setTimeout(() => {
            const elements = document.getElementsByClassName(props.overlayConfig ? props.overlayConfig.customClassName : '');
            for (const ele of elements) {
              ele.style.top = `${Number(ele.style.top.substring(0, ele.style.top.length - 2)) + props.overlayConfig.yAxisCorrection}px`;
              ele.style.left = `${Number(ele.style.left.substring(0, ele.style.left.length - 2)) + props.overlayConfig.xAxisCorrection}px`;
              ele.style.opacity = '1';
            }
          }, 0);
        } else {
          const elements = document.getElementsByClassName(props.overlayConfig ? props.overlayConfig.customClassName : '');
          for (const ele of elements) {
            ele.style.opacity = '0';
          }
        }
      }}
      className="ucd-dropdown-menu-container"
      overlay={
        <Menu className="ucd-dropdown-menu">
          {props.options.map((item, index) => {
            return (
              <Menu.Item
                disabled={item.disabled}
                onClick={(event) => {
                  item.callback(props.project);
                  event.domEvent.stopPropagation();
                }}
                key={item.value}
                className={`${
                  index < props.options.length - 1
                    ? 'ucd-menu-item ucd-menu-item-divider'
                    : 'ucd-menu-item'
                }${item.disabled ? ' ucd-menu-item-disabled' : ''}`}
              >
                <div
                  className={
                    item.disabled
                      ? 'ucd-menu-content-disabled'
                      : 'ucd-menu-content'
                  }
                >
                  <div style={{ position: 'relative', top: '3px' }}>
                    <img src={item.icon} height={'14px'} width={'14px'} alt={''} />
                  </div>
                  <div className="name">{item.displayName}</div>
                </div>
              </Menu.Item>
            );
          })}
        </Menu>
      }
    >
      <div className="iconContainer">
        <span className="single-select-menu-trigger">
          <MoreHorizontalUniversal
            style={{ fontSize: '16px', color: colorBaseNeutral700 }}
          />
        </span>
      </div>
    </Dropdown>
  );
};

export default SingleSelectMenu;
